// extracted by mini-css-extract-plugin
export default {"skills":"ListSkill_skills__i2oQ9","skillsTitle":"ListSkill_skillsTitle__nqVbs"};